import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './order-sheet_types.2';

export function createOrderSheet(variable: types.CreateOrderSheetVariables, options?: GqlRequestOptions) {
  const query = 'mutation CreateOrderSheet($input: CreateOrderSheetInput!) { createOrderSheet(input: $input) }';
  return gql_request<types.CreateOrderSheet, types.CreateOrderSheetVariables>('CreateOrderSheet', query, variable, { use_consumer: true, ...options });
}
